export function pxToRem(px: number): string {
  return `${px / 16}rem`;
}
